import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
